import { base_url, client_token } from "../http.js";

export const actions = {
  login: ({ commit, dispatch }, { vm, data }) => {
    return new Promise((resolve, reject) => {
      const path = "/auth/token/";
      const url = base_url + path;
      const headers = {
        Authorization: "Basic " + client_token
      };

      vm.$http
        .post(url, data, { headers: headers })
        .then(resp => {
          const access_token = resp.data.access_token;
          commit("set_access_token", access_token);
          const refresh_token = resp.data.refresh_token;
          commit("set_refresh_token", refresh_token);

          vm.$http.defaults.headers.common["Authorization"] =
            "Bearer " + access_token;

          resolve(resp);
        })
        .catch(err => {
          commit("delete_access_token");
          commit("delete_refresh_token");
          reject(err);
          // vm.$Message.error("Для работы с Товароучетной системой обратитесь в поддержку Light Kassa");
          vm.$Message.error("Проверьте корректность ввода логина или пароля. В случае повторной ошибки обратитесь в чат поддержки Light Kassa (правый нижний угол)");
        });
    });
  },

  logout({ commit, dispatch }, { vm }) {
    const path = "/auth/revoke_token/";
    const url = base_url + path;
    const headers = {
      Authorization: "Basic " + client_token
    };
    const access_token = vm.$store.state.access_token;
    const data = {
        token: access_token
    };

    vm.$http
      .post(url, data, { headers: headers })
      .then(resp => {
        commit("delete_access_token");
        commit("delete_refresh_token");
        //
        // vm.$http.defaults.headers.common["Authorization"] =
        //     "Bearer " + access_token;
        delete axios.defaults.headers.common['Authorization']

        resolve(resp);
      })
      .catch(err => {
        commit("delete_access_token");
        commit("delete_refresh_token");
        reject(err);
      });
  },

  refreshToken: ({ commit, dispatch }, { vm, refresh_token }) => {
    return new Promise((resolve, reject) => {
      const path = "/auth/token/";
      const url = base_url + path;
      // const refresh_token = vm.$store.state.refresh_token;
      const data = {
        grant_type: "refresh_token",
        refresh_token: refresh_token
      };
      const headers = {
        Authorization: "Basic " + client_token
      };

        // console.log("refreshed1");

      vm.$http
        .post(url, data, { headers: headers })
        .then(resp => {
          const access_token = resp.data.access_token;
          commit("set_access_token", access_token);
          const refresh_token = resp.data.refresh_token;
          commit("set_refresh_token", refresh_token);

          vm.$http.defaults.headers.common["Authorization"] =
            "Bearer " + access_token;

          resolve(resp.data.access_token);
        })
        .catch(err => {
          commit("delete_access_token");
          commit("delete_refresh_token");
          reject(err);
        });
    });
  },

  restoreTokensFromStorage({ commit, dispatch }, { vm }) {
    const access_token = localStorage.getItem("access_token");
    if (access_token) {
      commit("set_access_token", access_token);

      const refresh_token = localStorage.getItem("refresh_token");
      if (refresh_token) {
        commit("set_refresh_token", refresh_token);
      }
    }

    vm.$http.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${access_token}`;
  }
};



// WEBPACK FOOTER //
// ./src/store/actions.js